import { Input } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { FormlyTemplateOptions, FormlyFieldConfig } from '../components/formly.field.config';
/**
 * @abstract
 */
export abstract class Field {
   form: FormGroup;
   field: FormlyFieldConfig;
   model: any;
   options: any;
/**
 * @return {?}
 */
get key() { return this.field.key; }
/**
 * @return {?}
 */
get formControl(): AbstractControl { return this.field.formControl || this.form.get(this.key); }
/**
 * @return {?}
 */
get to(): FormlyTemplateOptions { return this.field.templateOptions; }
/**
 * @return {?}
 */
get showError(): boolean { return this.options.showError(this); }
/**
 * @return {?}
 */
get id(): string { return this.field.id; }
/**
 * @return {?}
 */
get formState() { return this.options.formState || {}; }
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'form': [{ type: Input },],
'field': [{ type: Input },],
'model': [{ type: Input },],
'options': [{ type: Input },],
};
}

function Field_tsickle_Closure_declarations() {
/** @type {?} */
Field.propDecorators;
/** @type {?} */
Field.prototype.form;
/** @type {?} */
Field.prototype.field;
/** @type {?} */
Field.prototype.model;
/** @type {?} */
Field.prototype.options;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
